// WARNING: This file is auto-generated from src/waldur_core/permissions/print_permission_enums.py
// Do not edit it manually. All manual changes would be overridden.
export const RoleEnum = {
  CUSTOMER_OWNER: 'CUSTOMER.OWNER',
  CUSTOMER_SUPPORT: 'CUSTOMER.SUPPORT',
  CUSTOMER_MANAGER: 'CUSTOMER.MANAGER',
  CUSTOMER_READER: 'CUSTOMER.READER',
  PROJECT_ADMIN: 'PROJECT.ADMIN',
  PROJECT_MANAGER: 'PROJECT.MANAGER',
  PROJECT_MEMBER: 'PROJECT.MEMBER',
  OFFERING_MANAGER: 'OFFERING.MANAGER',
  CALL_REVIEWER: 'CALL.REVIEWER',
  CALL_MANAGER: 'CALL.MANAGER',
  CALL_PANEL_MEMBER: 'CALL.PANEL_MEMBER',
  PROPOSAL_MEMBER: 'PROPOSAL.MEMBER',
  PROPOSAL_MANAGER: 'PROPOSAL.MANAGER',
  PROPOSAL_ADMIN: 'PROPOSAL.ADMIN',
};

export const PermissionMap = {
  customer: 'CUSTOMER.CREATE_PERMISSION',
  project: 'PROJECT.CREATE_PERMISSION',
  offering: 'OFFERING.CREATE_PERMISSION',
  call: 'CALL.CREATE_PERMISSION',
  proposal: 'PROPOSAL.MANAGE',
  call_organizer: 'CALL.CREATE_PERMISSION',
  service_provider: 'CUSTOMER.CREATE_PERMISSION',
  resource: 'RESOURCE.CREATE_PERMISSION',
  resource_project: 'RESOURCE_PROJECT.CREATE_PERMISSION',
};

export const PermissionEnum = {
  REGISTER_SERVICE_PROVIDER: 'SERVICE_PROVIDER.REGISTER',
  CREATE_OFFERING: 'OFFERING.CREATE',
  DELETE_OFFERING: 'OFFERING.DELETE',
  UPDATE_OFFERING_THUMBNAIL: 'OFFERING.UPDATE_THUMBNAIL',
  UPDATE_OFFERING: 'OFFERING.UPDATE',
  UPDATE_OFFERING_ATTRIBUTES: 'OFFERING.UPDATE_ATTRIBUTES',
  UPDATE_OFFERING_LOCATION: 'OFFERING.UPDATE_LOCATION',
  UPDATE_OFFERING_DESCRIPTION: 'OFFERING.UPDATE_DESCRIPTION',
  UPDATE_OFFERING_OPTIONS: 'OFFERING.UPDATE_OPTIONS',
  UPDATE_OFFERING_INTEGRATION: 'OFFERING.UPDATE_INTEGRATION',
  ADD_OFFERING_ENDPOINT: 'OFFERING.ADD_ENDPOINT',
  DELETE_OFFERING_ENDPOINT: 'OFFERING.DELETE_ENDPOINT',
  UPDATE_OFFERING_COMPONENTS: 'OFFERING.UPDATE_COMPONENTS',
  PAUSE_OFFERING: 'OFFERING.PAUSE',
  UNPAUSE_OFFERING: 'OFFERING.UNPAUSE',
  ARCHIVE_OFFERING: 'OFFERING.ARCHIVE',
  DRY_RUN_OFFERING_SCRIPT: 'OFFERING.DRY_RUN_SCRIPT',
  MANAGE_CAMPAIGN: 'OFFERING.MANAGE_CAMPAIGN',
  MANAGE_OFFERING_USER_GROUP: 'OFFERING.MANAGE_USER_GROUP',
  CREATE_OFFERING_PLAN: 'OFFERING.CREATE_PLAN',
  UPDATE_OFFERING_PLAN: 'OFFERING.UPDATE_PLAN',
  ARCHIVE_OFFERING_PLAN: 'OFFERING.ARCHIVE_PLAN',
  CREATE_OFFERING_SCREENSHOT: 'OFFERING.CREATE_SCREENSHOT',
  UPDATE_OFFERING_SCREENSHOT: 'OFFERING.UPDATE_SCREENSHOT',
  DELETE_OFFERING_SCREENSHOT: 'OFFERING.DELETE_SCREENSHOT',
  CREATE_OFFERING_USER: 'OFFERING.CREATE_USER',
  UPDATE_OFFERING_USER: 'OFFERING.UPDATE_USER',
  DELETE_OFFERING_USER: 'OFFERING.DELETE_USER',
  MANAGE_OFFERING_USER_ROLE: 'OFFERING.MANAGE_USER_ROLE',
  MANAGE_POSIX_ID_POOL: 'POSIX_ID_POOL.MANAGE',
  CREATE_RESOURCE_ROBOT_ACCOUNT: 'RESOURCE.CREATE_ROBOT_ACCOUNT',
  UPDATE_RESOURCE_ROBOT_ACCOUNT: 'RESOURCE.UPDATE_ROBOT_ACCOUNT',
  DELETE_RESOURCE_ROBOT_ACCOUNT: 'RESOURCE.DELETE_ROBOT_ACCOUNT',
  LIST_ORDERS: 'ORDER.LIST',
  CREATE_ORDER: 'ORDER.CREATE',
  APPROVE_PRIVATE_ORDER: 'ORDER.APPROVE_PRIVATE',
  APPROVE_ORDER: 'ORDER.APPROVE',
  REJECT_ORDER: 'ORDER.REJECT',
  DESTROY_ORDER: 'ORDER.DESTROY',
  CANCEL_ORDER: 'ORDER.CANCEL',
  SET_CONSUMER_ORDER_INFO: 'ORDER.SET_CONSUMER_INFO',
  LIST_RESOURCES: 'RESOURCE.LIST',
  UPDATE_RESOURCE: 'RESOURCE.UPDATE',
  TERMINATE_RESOURCE: 'RESOURCE.TERMINATE',
  LIST_IMPORTABLE_RESOURCES: 'RESOURCE.LIST_IMPORTABLE',
  SET_RESOURCE_END_DATE: 'RESOURCE.SET_END_DATE',
  SET_RESOURCE_USAGE: 'RESOURCE.SET_USAGE',
  SWITCH_RESOURCE_PLAN: 'RESOURCE.SET_PLAN',
  UPDATE_RESOURCE_LIMITS: 'RESOURCE.SET_LIMITS',
  SET_RESOURCE_BACKEND_ID: 'RESOURCE.SET_BACKEND_ID',
  SET_RESOURCE_SLUG: 'RESOURCE.SET_SLUG',
  SUBMIT_RESOURCE_REPORT: 'RESOURCE.SUBMIT_REPORT',
  SET_RESOURCE_BACKEND_METADATA: 'RESOURCE.SET_BACKEND_METADATA',
  MANAGE_RESOURCE_API_KEY: 'RESOURCE.MANAGE_API_KEY',
  SET_RESOURCE_STATE: 'RESOURCE.SET_STATE',
  UPDATE_RESOURCE_OPTIONS: 'RESOURCE.UPDATE_OPTIONS',
  ACCEPT_BOOKING_REQUEST: 'RESOURCE.ACCEPT_BOOKING_REQUEST',
  REJECT_BOOKING_REQUEST: 'RESOURCE.REJECT_BOOKING_REQUEST',
  MANAGE_RESOURCE_USERS: 'RESOURCE.MANAGE_USERS',
  CREATE_RESOURCE_PERMISSION: 'RESOURCE.CREATE_PERMISSION',
  UPDATE_RESOURCE_PERMISSION: 'RESOURCE.UPDATE_PERMISSION',
  DELETE_RESOURCE_PERMISSION: 'RESOURCE.DELETE_PERMISSION',
  CREATE_RESOURCE_PROJECT_PERMISSION: 'RESOURCE_PROJECT.CREATE_PERMISSION',
  UPDATE_RESOURCE_PROJECT_PERMISSION: 'RESOURCE_PROJECT.UPDATE_PERMISSION',
  DELETE_RESOURCE_PROJECT_PERMISSION: 'RESOURCE_PROJECT.DELETE_PERMISSION',
  RESOURCE_CONSUMPTION_LIMITATION: 'RESOURCE.CONSUMPTION_LIMITATION',
  MANAGE_OFFERING_BACKEND_RESOURCES: 'OFFERING.MANAGE_BACKEND_RESOURCES',
  GET_SERVICE_PROVIDER_API_SECRET_CODE: 'SERVICE_PROVIDER.GET_API_SECRET_CODE',
  GENERATE_SERVICE_PROVIDER_API_SECRET_CODE: 'SERVICE_PROVIDER.GENERATE_API_SECRET_CODE',
  LIST_SERVICE_PROVIDER_CUSTOMERS: 'SERVICE_PROVIDER.LIST_CUSTOMERS',
  LIST_SERVICE_PROVIDER_CUSTOMER_PROJECTS: 'SERVICE_PROVIDER.LIST_CUSTOMER_PROJECTS',
  LIST_SERVICE_PROVIDER_PROJECTS: 'SERVICE_PROVIDER.LIST_PROJECTS',
  LIST_SERVICE_PROVIDER_PROJECT_PERMISSIONS: 'SERVICE_PROVIDER.LIST_PROJECT_PERMISSIONS',
  LIST_SERVICE_PROVIDER_KEYS: 'SERVICE_PROVIDER.LIST_KEYS',
  LIST_SERVICE_PROVIDER_USERS: 'SERVICE_PROVIDER.LIST_USERS',
  LIST_SERVICE_PROVIDER_USER_CUSTOMERS: 'SERVICE_PROVIDER.LIST_USER_CUSTOMERS',
  LIST_SERVICE_PROVIDER_SERVICE_ACCOUNTS: 'SERVICE_PROVIDER.LIST_SERVICE_ACCOUNTS',
  LIST_SERVICE_PROVIDER_COURSE_ACCOUNTS: 'SERVICE_PROVIDER.LIST_COURSE_ACCOUNTS',
  SET_SERVICE_PROVIDER_OFFERINGS_USERNAME: 'SERVICE_PROVIDER.SET_OFFERINGS_USERNAME',
  GET_SERVICE_PROVIDER_STATISTICS: 'SERVICE_PROVIDER.GET_STATISTICS',
  GET_SERVICE_PROVIDER_REVENUE: 'SERVICE_PROVIDER.GET_REVENUE',
  GET_SERVICE_PROVIDER_ROBOT_ACCOUNT_CUSTOMERS: 'SERVICE_PROVIDER.GET_ROBOT_ACCOUNT_CUSTOMERS',
  GET_SERVICE_PROVIDER_ROBOT_ACCOUNT_PROJECTS: 'SERVICE_PROVIDER.GET_ROBOT_ACCOUNT_PROJECTS',
  MANAGE_MAINTENANCE_ANNOUNCEMENT: 'SERVICE_PROVIDER.MANAGE_MAINTENANCE_ANNOUNCEMENT',
  CREATE_MATRIX_ROOM: 'MATRIX_ROOM.CREATE',
  CREATE_PROJECT_PERMISSION: 'PROJECT.CREATE_PERMISSION',
  CREATE_CUSTOMER_PERMISSION: 'CUSTOMER.CREATE_PERMISSION',
  CREATE_OFFERING_PERMISSION: 'OFFERING.CREATE_PERMISSION',
  CREATE_CALL_PERMISSION: 'CALL.CREATE_PERMISSION',
  MANAGE_PROPOSAL: 'PROPOSAL.MANAGE',
  UPDATE_PROPOSAL: 'PROPOSAL.UPDATE',
  MANAGE_PROPOSAL_REVIEW: 'PROPOSAL.MANAGE_REVIEW',
  UPDATE_PROJECT_PERMISSION: 'PROJECT.UPDATE_PERMISSION',
  UPDATE_CUSTOMER_PERMISSION: 'CUSTOMER.UPDATE_PERMISSION',
  UPDATE_OFFERING_PERMISSION: 'OFFERING.UPDATE_PERMISSION',
  UPDATE_CALL_PERMISSION: 'CALL.UPDATE_PERMISSION',
  UPDATE_PROPOSAL_PERMISSION: 'PROPOSAL.UPDATE_PERMISSION',
  DELETE_PROJECT_PERMISSION: 'PROJECT.DELETE_PERMISSION',
  DELETE_CUSTOMER_PERMISSION: 'CUSTOMER.DELETE_PERMISSION',
  DELETE_OFFERING_PERMISSION: 'OFFERING.DELETE_PERMISSION',
  DELETE_CALL_PERMISSION: 'CALL.DELETE_PERMISSION',
  DELETE_PROPOSAL_PERMISSION: 'PROPOSAL.DELETE_PERMISSION',
  CREATE_LEXIS_LINK: 'LEXIS_LINK.CREATE',
  DELETE_LEXIS_LINK: 'LEXIS_LINK.DELETE',
  LIST_PROJECTS: 'PROJECT.LIST',
  CREATE_PROJECT: 'PROJECT.CREATE',
  DELETE_PROJECT: 'PROJECT.DELETE',
  UPDATE_PROJECT: 'PROJECT.UPDATE',
  UPDATE_PROJECT_METADATA: 'PROJECT.UPDATE_METADATA',
  SET_PROJECT_SLUG: 'PROJECT.SET_SLUG',
  REVIEW_PROJECT_MEMBERSHIP: 'PROJECT.REVIEW_MEMBERSHIP',
  UPDATE_CUSTOMER: 'CUSTOMER.UPDATE',
  CUSTOMER_CONTACT_UPDATE: 'CUSTOMER.CONTACT_UPDATE',
  LIST_CUSTOMER_USERS: 'CUSTOMER.LIST_USERS',
  VIEW_CUSTOMER_TEAM: 'CUSTOMER.VIEW_TEAM',
  VIEW_PROJECT_TEAM: 'PROJECT.VIEW_TEAM',
  ACCEPT_REQUESTED_OFFERING: 'OFFERING.ACCEPT_CALL_REQUEST',
  APPROVE_AND_REJECT_PROPOSALS: 'CALL.APPROVE_AND_REJECT_PROPOSALS',
  CLOSE_ROUNDS: 'CALL.CLOSE_ROUNDS',
  CREATE_ACCESS_SUBNET: 'ACCESS_SUBNET.CREATE',
  UPDATE_ACCESS_SUBNET: 'ACCESS_SUBNET.UPDATE',
  DELETE_ACCESS_SUBNET: 'ACCESS_SUBNET.DELETE',
  CREATE_OFFERING_ACCESS_SUBNET: 'OFFERING_ACCESS_SUBNET.CREATE',
  UPDATE_OFFERING_ACCESS_SUBNET: 'OFFERING_ACCESS_SUBNET.UPDATE',
  DELETE_OFFERING_ACCESS_SUBNET: 'OFFERING_ACCESS_SUBNET.DELETE',
  UPDATE_OFFERING_USER_RESTRICTION: 'OFFERINGUSER.UPDATE_RESTRICTION',
  LIST_INVITATIONS: 'INVITATION.LIST',
  LIST_CUSTOMER_PERMISSION_REVIEWS: 'CUSTOMER.LIST_PERMISSION_REVIEWS',
  LIST_CALLS: 'CALL.LIST',
  CREATE_CALL: 'CALL.CREATE',
  UPDATE_CALL: 'CALL.UPDATE',
  LIST_ROUNDS: 'ROUND.LIST',
  LIST_PROPOSALS: 'PROPOSAL.LIST',
  MANAGE_SERVICE_ACCOUNT: 'SERVICE_ACCOUNT.MANAGE',
  MANAGE_COURSE_ACCOUNT: 'PROJECT.COURSE_ACCOUNT_MANAGE',
  SERVICE_PROVIDER_OPENSTACK_IMAGE_MANAGEMENT: 'SERVICE_PROVIDER.OPENSTACK_IMAGE_MANAGEMENT',
  HAS_OPENSTACK_INSTANCE_CONSOLE_ACCESS: 'OPENSTACK_INSTANCE.CONSOLE_ACCESS',
  CAN_MANAGE_OPENSTACK_INSTANCE_POWER: 'OPENSTACK_INSTANCE.MANAGE_POWER',
  CAN_MANAGE_OPENSTACK_INSTANCE: 'OPENSTACK_INSTANCE.MANAGE',
  CAN_MANAGE_OPENSTACK_ROUTER_GATEWAY: 'OPENSTACK_ROUTER.MANAGE_GATEWAY',
  STAFF_ACCESS: 'STAFF.ACCESS',
  SUPPORT_ACCESS: 'SUPPORT.ACCESS',
};
